<template>
  <TutorialScreen
    v-show="show"
    :screen-name="$t('stamp.tutorial.title')"
    :screen-info="$t('stamp.tutorial.clench_fingers')"
    @skip="$emit('skip')"
  >
    <TutorialDoll :currentScreen="currentScreen" />
  </TutorialScreen>
</template>

<script>
import incein from '@/mixins/incein';
import autoNext from '@/mixins/auto-next';

import TutorialScreen from '../Screen.vue';
import TutorialDoll from '../TutorialDoll.vue';

import fullBody from '../../../assets/stamp/doll-relax-zoom.png';
import greyCircle from '../../../assets/stamp/circle-4.png';
import greyCircleIncein from '../../../assets/stamp/incein-circle-4.svg';

export default {
  name: 'ClenchFingers1',
  components: {
    TutorialScreen,
    TutorialDoll,
  },
  mixins: [autoNext, incein],
  data: () => ({
    duration: 2,
    playThrough: false,
  }),
  computed: {
    currentScreen() {
      return {
        src: fullBody,
        zoom: 'fullBodyZoom',
        frontImg: [
          {
            id: 1,
            src: this.isIncein ? greyCircleIncein : greyCircle,
            cls: 'handCircle mx-16 lg:mx-0 lg:mr-24 mt-12',
          },
          {
            id: 2,
            src: this.isIncein ? greyCircleIncein : greyCircle,
            cls: 'handCircle mx-16 lg:mx-0 lg:ml-32 mt-12',
          },
        ],
      };
    },
  },
};
</script>
